import React, { useCallback } from 'react'
import { connect } from 'react-redux'
import api, { apiAction } from '../../api'
import { withRouter } from 'react-router-dom'

import useModel from '../../common/useModel'
import S from './styled'
import { getTheme } from '../../themes'

import {
  Input,
  Button,
} from  '../../components'

const theme = getTheme()

const defaultModel = {
  values: {
    username: '',
    password: '',
  },
}

const LoginForm = ({ login, loginError, doNotRedirect, history, loggingIn }) => {

  const { model, text } = useModel(defaultModel)
  const canSubmit = model.values.username && model.values.password

  const onSubmit = useCallback(event => {
    event.preventDefault()
    event.stopPropagation()
    if (canSubmit && !loggingIn) {
      login(model.values.username, model.values.password).then(payload => {
        if(!doNotRedirect) {
          const backTo = history.location.search.includes('backTo=') ? history.location.search.replace('?backTo=', '') : '/'
          history.replace(backTo)
        }
      })
    }
    return false
  }, [canSubmit, loggingIn, login, model.values.username, model.values.password, doNotRedirect, history])

  return (
    <S.FormContainer>
      <img src={theme.logoFull} alt="Logo"/>
      <form onSubmit={onSubmit}>
        <Input {...{
          name: 'values.username', text,
          title: 'Username',
          inverted: true,
          autoFocus: true,
        }}/>

        <Input {...{
          name: 'values.password', text,
          title: 'Password',
          inverted: true,
          type: 'password',
        }}/>
        { loginError && <S.ErrorLabel>{loginError}</S.ErrorLabel> }
        <Button
          onClick={loggingIn ? null : onSubmit}
          disabled={loggingIn ? false : !canSubmit}
          progress={loggingIn}>
          {loggingIn ? 'Submitting...' : 'Submit'}
        </Button>
      </form>
    </S.FormContainer>
  )
}

const mapStateToProps = state => ({
  sessionExpired: state.session.expired,
  loginError: state.session.error,
  loggingIn: state.session.loggingIn,
})

const mapDispatchToProps = dispatch => ({
  login: ( login, password ) => dispatch(apiAction(api.login)({ login, password }, { quite: true })),
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LoginForm))
